import React from 'react';
import NavItem from './NavItem';
import { NavLinkWithSubmenu, Link, Section } from '../data/NavItemsAdmin';
import SidebarFooter from './Sidebar-footer';

interface SidebarDesktopProps {
  navItems: Section[];
}

// Type guard function to determine if a link has a submenu
function hasSubmenu(link: Link): link is NavLinkWithSubmenu {
  return (link as NavLinkWithSubmenu).submenu !== undefined;
}

const SidebarDesktop: React.FC<SidebarDesktopProps> = ({ navItems }) => {
  return (
    <div className="sidebar d-none d-md-block" id="sidebar-desktop">
      <ul className="nav flex-column p-1">
        {navItems.map((section, index) => (
          <React.Fragment key={index}>
            {section.sectionTitle && (
              <li className="nav-section-title">{section.sectionTitle}</li>
            )}
            {section.links.map((link, idx) =>
              hasSubmenu(link) ? (
                <NavItem
                  key={idx}
                  name={link.name}
                  icon={link.icon}
                  href={link.href}
                  submenuId={link.submenuId}
                  submenu={link.submenu}
                />
              ) : (
                <NavItem key={idx} name={link.name} icon={link.icon} href={link.href} />
              )
            )}
          </React.Fragment>
        ))}
      </ul>
      <SidebarFooter />
    </div>
  );
};

export default SidebarDesktop;
